import React, { useState } from 'react';
import Select from 'react-select';

const PincodeModal = ({ isOpen, setIsOpen, pincodeData, setPincodeData, handleChange, handleSubmit, statusOptions, availableOptions, loadButton }) => {


    if (!isOpen) return null;





    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"

            >
                <h2 className="oms-modal-title">Pincode details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="pincode" className="oms-form-label">
                            Pincode
                        </label>
                        <input
                            type="text"
                            id="pincode"
                            name="pincode"
                            value={pincodeData.pincode}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (/^\d{0,6}$/.test(val)) {
                                    setPincodeData((prev) => ({ ...prev, pincode: val }));
                                }
                            }}
                            placeholder="Enter 6-digit pincode"
                            maxLength={6}
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="available" className="oms-form-label">
                            Available
                        </label>
                        <Select
                            id="available"
                            name='available'
                            options={availableOptions}
                            value={pincodeData.available}
                            onChange={(selectedOption) =>
                                setPincodeData((prev) => ({ ...prev, available: selectedOption }))
                            }

                            placeholder="Select Include/Exclude"
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select
                            id="status"
                            name='status'
                            options={statusOptions}
                            value={pincodeData.status}
                            onChange={(selectedOption) =>
                                setPincodeData((prev) => ({ ...prev, status: selectedOption }))
                            }

                            placeholder="Select status"
                            required
                        />
                    </div>


                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {
                            loadButton ? <button type="button">Adding...</button> :
                                <button type="submit">Add</button>
                        }

                    </div>
                </form>
            </div>
        </div>
    );
};

export default PincodeModal;
